import React, { FC } from "react"
import tada from "../../../../../Common/Assets/tada.png"
import { NavButton } from "../../../../../Common/NavButton/NavButton"
import { routePaths } from "../../../../../../Routes"

export const EmptyState: FC<{ canCreateApp: boolean }> = ({ canCreateApp }) => {
    return (
        <div className="w-full h-full flex items-center justify-center text-rhino-700">
            <div className="flex flex-col items-center pb-16">
                <img
                    src={tada}
                    alt="Party clacker"
                    style={{
                        filter: "grayscale(100%)",
                        width: "200px"
                    }}
                    className="ml-8 mb-3"
                />
                <p className="text-center p-3 text-lg">
                    Welcome to the dashboard! Great
                    <br />
                    to have you here
                </p>
                {canCreateApp ? (
                    <NavButton
                        to={routePaths.store()}
                        className="w-auto px-10"
                        testId="first-btn"
                    >
                        Create first project
                    </NavButton>
                ) : (
                    <p>
                        Projects that you've been invited to will be shown here
                    </p>
                )}
            </div>
        </div>
    )
}
